import dom from '../../utils/dom';
import AccountCreateUpdateFormHandler from '../AccountCreateUpdateFormHandler';

window.tnew.page.initialize = ({ isAddressVerificationEnabled, stateFilterConfig, isRecaptchaEnabled }) => {
  const $form = dom.find('#tn-account-register-form');

  const isAddressSectionDisplayed = true;

  new AccountCreateUpdateFormHandler($form, isAddressVerificationEnabled, stateFilterConfig, isAddressSectionDisplayed, null, isRecaptchaEnabled);
};
